/** Selected tier tint (light surface + dark numeral for WCAG contrast). */
export const CONFIDENCE_LEVEL_SOLID = [
    'bg-red-200 dark:bg-red-950/60',
    'bg-orange-200 dark:bg-orange-950/60',
    'bg-amber-200 dark:bg-amber-950/60',
    'bg-lime-200 dark:bg-lime-950/60',
    'bg-emerald-200 dark:bg-emerald-950/60'
] as const;
